/**
 * Roadmap 1870 (owner, 2026-10-22): only the person who wrote a note may EDIT
 * it, Admins included. Admins may still DELETE other people's notes. The
 * server refuses other people's edits too (403).
 */
export const isNoteAuthor = (
  createdByUserId: string | null | undefined,
  myIds: Array<string | null | undefined>,
): boolean => {
  if (!createdByUserId) return false;
  const author = `${createdByUserId}`.toLowerCase();
  return myIds.some((id) => !!id && `${id}`.toLowerCase() === author);
};
